{
  "source": "https://chromium-i18n.appspot.com/ssl-address/data/US",
  "zip": "(\\d{5})(?:[ \\-](\\d{4}))?",
  "regions": [
    {
      "code": "AL",
      "name": "Alabama",
      "zip": "3[56]"
    },
    {
      "code": "AK",
      "name": "Alaska",
      "zip": "99[5-9]"
    },
    {
      "code": "AS",
      "name": "American Samoa",
      "zip": "96799"
    },
    {
      "code": "AZ",
      "name": "Arizona",
      "zip": "8[56]"
    },
    {
      "code": "AR",
      "name": "Arkansas",
      "zip": "71[6-9]|72"
    },
    {
      "code": "AA",
      "name": "Armed Forces (AA)",
      "zip": "340"
    },
    {
      "code": "AE",
      "name": "Armed Forces (AE)",
      "zip": "09"
    },
    {
      "code": "AP",
      "name": "Armed Forces (AP)",
      "zip": "96[2-6]"
    },
    {
      "code": "CA",
      "name": "California",
      "zip": "9[0-5]|96[01]"
    },
    {
      "code": "CO",
      "name": "Colorado",
      "zip": "8[01]"
    },
    {
      "code": "CT",
      "name": "Connecticut",
      "zip": "06"
    },
    {
      "code": "DE",
      "name": "Delaware",
      "zip": "19[7-9]"
    },
    {
      "code": "DC",
      "name": "District of Columbia",
      "zip": "20[02-5]|569"
    },
    {
      "code": "FL",
      "name": "Florida",
      "zip": "3[23]|34[1-9]"
    },
    {
      "code": "GA",
      "name": "Georgia",
      "zip": "3[01]|398|39901"
    },
    {
      "code": "GU",
      "name": "Guam",
      "zip": "969([1-2]\\d|3[12])"
    },
    {
      "code": "HI",
      "name": "Hawaii",
      "zip": "967[0-8]|9679[0-8]|968"
    },
    {
      "code": "ID",
      "name": "Idaho",
      "zip": "83[2-9]"
    },
    {
      "code": "IL",
      "name": "Illinois",
      "zip": "6[0-2]"
    },
    {
      "code": "IN",
      "name": "Indiana",
      "zip": "4[67]"
    },
    {
      "code": "IA",
      "name": "Iowa",
      "zip": "5[0-2]"
    },
    {
      "code": "KS",
      "name": "Kansas",
      "zip": "6[67]"
    },
    {
      "code": "KY",
      "name": "Kentucky",
      "zip": "4[01]|42[0-7]"
    },
    {
      "code": "LA",
      "name": "Louisiana",
      "zip": "70|71[0-5]"
    },
    {
      "code": "ME",
      "name": "Maine",
      "zip": "039|04"
    },
    {
      "code": "MH",
      "name": "Marshall Islands",
      "zip": "969[67]"
    },
    {
      "code": "MD",
      "name": "Maryland",
      "zip": "20[6-9]|21"
    },
    {
      "code": "MA",
      "name": "Massachusetts",
      "zip": "01|02[0-7]|05501|05544"
    },
    {
      "code": "MI",
      "name": "Michigan",
      "zip": "4[89]"
    },
    {
      "code": "FM",
      "name": "Micronesia",
      "zip": "9694[1-4]"
    },
    {
      "code": "MN",
      "name": "Minnesota",
      "zip": "55|56[0-7]"
    },
    {
      "code": "MS",
      "name": "Mississippi",
      "zip": "38[6-9]|39[0-7]"
    },
    {
      "code": "MO",
      "name": "Missouri",
      "zip": "6[3-5]"
    },
    {
      "code": "MT",
      "name": "Montana",
      "zip": "59"
    },
    {
      "code": "NE",
      "name": "Nebraska",
      "zip": "6[89]"
    },
    {
      "code": "NV",
      "name": "Nevada",
      "zip": "889|89"
    },
    {
      "code": "NH",
      "name": "New Hampshire",
      "zip": "03[0-8]"
    },
    {
      "code": "NJ",
      "name": "New Jersey",
      "zip": "0[78]"
    },
    {
      "code": "NM",
      "name": "New Mexico",
      "zip": "87|88[0-4]"
    },
    {
      "code": "NY",
      "name": "New York",
      "zip": "1[0-4]|06390|00501|00544"
    },
    {
      "code": "NC",
      "name": "North Carolina",
      "zip": "2[78]"
    },
    {
      "code": "ND",
      "name": "North Dakota",
      "zip": "58"
    },
    {
      "code": "MP",
      "name": "Northern Mariana Islands",
      "zip": "9695[0-2]"
    },
    {
      "code": "OH",
      "name": "Ohio",
      "zip": "4[3-5]"
    },
    {
      "code": "OK",
      "name": "Oklahoma",
      "zip": "7[34]"
    },
    {
      "code": "OR",
      "name": "Oregon",
      "zip": "97"
    },
    {
      "code": "PW",
      "name": "Palau",
      "zip": "969(39|40)"
    },
    {
      "code": "PA",
      "name": "Pennsylvania",
      "zip": "1[5-8]|19[0-6]"
    },
    {
      "code": "PR",
      "name": "Puerto Rico",
      "zip": "00[679]"
    },
    {
      "code": "RI",
      "name": "Rhode Island",
      "zip": "02[89]"
    },
    {
      "code": "SC",
      "name": "South Carolina",
      "zip": "29"
    },
    {
      "code": "SD",
      "name": "South Dakota",
      "zip": "57"
    },
    {
      "code": "TN",
      "name": "Tennessee",
      "zip": "37|38[0-5]"
    },
    {
      "code": "TX",
      "name": "Texas",
      "zip": "7[5-9]|885|73301|73344"
    },
    {
      "code": "UT",
      "name": "Utah",
      "zip": "84"
    },
    {
      "code": "VT",
      "name": "Vermont",
      "zip": "05"
    },
    {
      "code": "VI",
      "name": "Virgin Islands",
      "zip": "008"
    },
    {
      "code": "VA",
      "name": "Virginia",
      "zip": "201|2[23]|24[0-6]"
    },
    {
      "code": "WA",
      "name": "Washington",
      "zip": "98|99[0-4]"
    },
    {
      "code": "WV",
      "name": "West Virginia",
      "zip": "24[7-9]|2[56]"
    },
    {
      "code": "WI",
      "name": "Wisconsin",
      "zip": "5[34]"
    },
    {
      "code": "WY",
      "name": "Wyoming",
      "zip": "82|83[01]|83414"
    }
  ]
}
